import {ApiException, NonModelledElementsExportClient} from "@api/apiClient";
import axios from "@api/axiosInstance";

const nonModelledElementsExportClient = new NonModelledElementsExportClient(
  undefined,
  axios
);

export interface ExportStartResponse {
  jobId: string;
  filename: string;
}

export async function startExport(): Promise<ExportStartResponse> {
  const response = await nonModelledElementsExportClient.startExport();
  return {
    jobId: response?.jobId ?? "",
    filename: response?.filename ?? "",
  };
}

export async function getExportFile(
  jobId: string
): Promise<{ blob: Blob; filename: string } | null> {
  try {
    const fileResponse = await nonModelledElementsExportClient.getExportFile(
      jobId
    );
    if (!fileResponse?.data) return null;
    return {
      blob: fileResponse.data,
      filename:
        fileResponse.fileName ?? "NonModelledElements.xlsx",
    };
  } catch (e) {
    if (ApiException.isApiException(e) && e.status === 202) return null;
    throw e;
  }
}
